<template>
  <div class="is-pulled-right review-actions customer" v-if="result.isNotOK()">
    <button
      class="button check is-outlined radius-circle"
      :class="[ result.finding.hasAnsweredFinding() ? 'is-info' : 'is-danger' ]"
      @click="$emit('showFinding', result)">
        <span class="icon is-medium">
          <i class="mdi mdi-exclamation"></i>
        </span>
    </button>
  </div>
</template>

<script>
  import { ReviewResult } from '@/classes/case/ReviewResult'

  export default {
    name: 'review-customer-actions-component',
    props: {
      result: {
        type: ReviewResult,
        required: true
      }
    }
  }
</script>
